<div class="container h-100">
    <div class="row h-100 justify-content-center align-items-center">
        <div *ngIf="isLoading" class="text-center">
            <app-loading-spinner></app-loading-spinner>
        </div>
        <div class="card SmallForm rounded" *ngIf="isLoading == false"
            [class.SmallArabicFont]="globalService.isRTL == true">
            <div class="card-header MyCardHeader rounded-top">
                <div class="input-group">
                    <div class="form-control MyCardTitle">
                        <h2 class="Head">
                            {{ globalService.Get("SELECTTENANT") }}
                        </h2>
                    </div>
                </div>
            </div>
            <div class="card-body MyCardBody rounded-bottom">
                <form #myForm="ngForm" (ngSubmit)="onSubmit(myForm)">
                    <div class="form-group row m-3" [class.text-right]="globalService.isRTL == true">
                        <label for="church" [class.SmallArabicFont]="globalService.isRTL == true">{{
                            globalService.Get("CHURCH_ID") }}</label>
                        <input type="text" id="church" class="form-control text-left" dir="ltr" ngModel name="churchId"
                            required #churchId="ngModel" />
                        <small class="help-block" *ngIf="!churchId.valid && churchId.touched">{{
                            globalService.Get("CHURCH_ID_REQUIRED")
                            }}</small> 
                    </div>
                    <app-prompt-message class="form-group row m-3" [showForm]="UnknownTenant == true" color="danger" (onClose)="UnknownTenant = false"
                       message="Unrecognized Church ID">
                    </app-prompt-message>                    
                    <div class="form-group m-3" [class.SmallArabicFont]="globalService.isRTL == true">
                        <div class="row">
                          <div class="col-12">
                            <button class="btn btn-primary btn-block" type="submitReactiveFormsModule">
                                <i *ngIf="SwitchingChurch == true" class="fas fa-spinner fa-spin"></i>
                              {{ globalService.Get("OPEN_CHURCH") }}
                            </button>
                          </div> 
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>